// extracted by mini-css-extract-plugin
export default {"group":"uVGvS","collapsed":"ho0uq","arrow":"VCJHC","withoutTitle":"oFpAk","content":"NtpRq","head":"MHl6S","title":"ZaJrN","right":"REQ2p","selectedText":"kEzxC","item":"BrPtL"};